<template>
	<div>
		<div class="layout">
			<!--
			<div class="align-between">
				<div class="title-select-wrap">
					<button type="button" class="title" ref="subMenuTitle" @click="eventClickSubMenu($event.target)">대회 안내</button>
					<div ref="subMenuItem">
						<ul class="subGnb-depth03 title-menu">
						<li>
							<router-link :to="{name: '통계 데이터 활용 대회'}">대회 안내</router-link>
						</li>
						<li>
							<router-link :to="{name: '대회 공지사항'}">대회 공지사항</router-link>
						</li>
						</ul>
					</div>
				</div>
			</div>
			-->
		</div>
		<div class="layout">
			<h2 class="title blind">대회 공지사항</h2>
			<div class="search-wrap align-between">
			<span class="total">전체 : <span>{{ total }}</span>건</span>
			<div class="search-box">
				<label for="nameCont" class="ir">제목/내용</label>
				<select name="" id="nameCont">
				<option value="">제목 / 내용</option>
				</select>
				<label for="searchText" class="ir">검색창</label>
				<input type="search" v-model="searchText" v-on:keyup.enter="searchBoardTotalList(1, 10, 1)" id="searchText"/>
				<button type="submit" @click="searchBoardTotalList(1, 10, 1)">검색</button>
			</div>
			</div>
			<DucNoticeListItem :board-list-data="listData" :searchText="this.searchText" :boardName="this.boardName" @showDetailView="showDetailView"/>
			<BoardPagination :pageSetting="pageDataSetting(this.page)" @paging="pagingMethod"/>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import * as api from '@/api/Notice.js'
import DucNoticeListItem from '@/components/DucNoticeListItem'
import BoardPagination from '@/components/BoardPagination'

export default {
	name: 'DucNotice',

	components: {
		DucNoticeListItem,
		BoardPagination
	},

	data () {
		return {
			boardType: '000312',
			boardName: '대회 공지사항',
			searchText: '',
			listData: [],
			total: 0,
			page: 1,
			limit: 10,
			block: 10,
			startIdx: 1,
			endIdx: 10
		}
	},

	created () {
		this.initBoard()
	},

	mounted () {
		if (window.innerWidth <= 768) {
			this.block = 5
		}
    const selector = document.querySelector('.router-link-active');
    if (selector) {
      document.querySelector('.title-select-wrap > button').textContent = selector.innerText
    }
	},

	methods: {
		eventClickSubMenu (target) {
		if (target) {
			const subMenuItemDiv = target.nextElementSibling
			if (subMenuItemDiv && subMenuItemDiv.children) {
			const subMenuItemUl = subMenuItemDiv.querySelector('.subGnb-depth03')
			const obj = subMenuItemUl.children[0]
			if (subMenuItemUl.style.display === 'block') {
				$(subMenuItemDiv.children[0]).stop().slideUp()
			} else {
				$(subMenuItemDiv.children[0]).stop().slideDown()
			}
			}
		}
		},
		initBoard () {
			if (this.$route.query.page) {
				this.page = this.$route.query.page
			}

			if (this.$route.query.searchText) {
				this.searchText = this.$route.query.searchText
			}

			this.searchBoardTotalList(this.page)
		},

		// 게시판 상세보기 화면 이동
		showDetailView (boardId, boardType, orderRowNum) {
			const paramData = {
				boardId: boardId,
				boardType: boardType,
				target: '통계 활용대회',
				page: this.page + '',
				searchText: this.searchText,
				orderRowNum: orderRowNum
			}

			this.$router.push({ name: '대회 공지사항 상세', query: paramData })
		},

		// 게시판 전체 목록
		async searchBoardTotalList (currentPage) {
			this.startIdx = ((currentPage - 1) * this.limit) + 1
			this.endIdx = currentPage * this.limit
			this.page = currentPage

			const paramData = {
				boardType: this.boardType,
				searchText: this.searchText,
				startPage: this.startIdx,
				endPage: this.endIdx
			}

			const boardData = await api.searchBoardList(paramData)
			this.listData = boardData.data

			const totalCnt = await api.boardCnt(paramData)
			this.total = totalCnt.cnt
			this.pageDataSetting(currentPage)
		},

		pagingMethod (page) {
			this.$router.replace({
				name: '통계 활용대회',
				query: {
					page: page,
					searchText: this.searchText
				}
			}).catch(() => {})
		},

		pageDataSetting (currentPage) {
			const totalPage = Math.ceil(this.total / this.limit)
			const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null
			const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null

			const startIndex = (Math.ceil(currentPage / this.block) - 1) * this.block + 1
			const endIndex = startIndex + this.block > totalPage ? totalPage : startIndex + this.block - 1
			const list = []
			for (let index = startIndex; index <= endIndex; index++) {
				list.push(index)
			}
			return { first, end, list, currentPage, totalPage }
		}
	},

	watch: {
		$route (to, from) {
			if (to.path == from.path) {
				this.initBoard()
			}
		}
	}
}
</script>

<style scoped>

</style>
